import { useEffect, useState } from 'react'
import { Platform, useWindowDimensions } from 'react-native'

export function useViewportHeights() {
  const { height: windowHeight } = useWindowDimensions()
  const [visualViewportHeight, setVisualViewportHeight] = useState<
    number | null
  >(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') {
      return null
    }

    return window.visualViewport?.height ?? window.innerHeight
  })

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') {
      return
    }

    const viewport = window.visualViewport
    const handleViewportChange = () => {
      setVisualViewportHeight(viewport?.height ?? window.innerHeight)
    }

    handleViewportChange()
    viewport?.addEventListener('resize', handleViewportChange)
    viewport?.addEventListener('scroll', handleViewportChange)
    window.addEventListener('resize', handleViewportChange)

    return () => {
      viewport?.removeEventListener('resize', handleViewportChange)
      viewport?.removeEventListener('scroll', handleViewportChange)
      window.removeEventListener('resize', handleViewportChange)
    }
  }, [])

  const resolvedVisualViewportHeight =
    Platform.OS === 'web'
      ? Math.min(windowHeight, visualViewportHeight ?? windowHeight)
      : windowHeight

  return {
    visualViewportHeight: resolvedVisualViewportHeight,
    windowHeight,
  }
}

export function getBrowserUserAgent(): string | null {
  if (Platform.OS !== 'web' || typeof navigator === 'undefined') {
    return null
  }

  return navigator.userAgent
}
